import React from "react";

import { Box, Flex } from "atoms";

export const Tooltip = ({
  render,
  children,
  flexProps,
  xAlign = "center",
  isTooltipArrow,
  ...props
}) => {
  return (
    <Flex
      css={{
        "& > :hover + span": {
          display: render ? "initial" : "none",
        },
      }}
      h="max-content !important"
      {...flexProps}
    >
      {children}
      <Box
        as="span"
        {...(xAlign === "right"
          ? { right: "0% !important" }
          : {
              left:
                xAlign === "left"
                  ? "0% !important"
                  : "calc(50% + 4px) !important",
            })}
        zIndex={1}
        color="white !important"
        display="none"
        top="120% !important"
        p="1rem 1.6rem !important"
        bg="rgba(0, 0, 0, 0.8) !important"
        w="max-content !important"
        position="absolute !important"
        bR="0.8rem !important"
        transform={
          xAlign === "center"
            ? "translateX(-50%) !important"
            : "none !important"
        }
        boxShadow="0 0 5px rgba(0,0,0,0.1) !important"
        {...props}
      >
        {isTooltipArrow && (
          <Box
            top="-4px !important"
            w="0px !important"
            h="0px !important"
            position="absolute !important"
            borderleft="8px solid transparent  !important"
            borderRight="8px solid transparent  !important"
            borderBottom="8px solid rgba(0, 0, 0, 0.8)  !important"
            left={
              xAlign === "center"
                ? "calc(50%) !important"
                : xAlign === "right"
                ? "calc(100% - 15px) !important"
                : "calc(0% + 4px) !important"
            }
            transform="rotate(135deg) !important"
            // bg={props.bg || "rgba(0, 0, 0, 0.8) !important"}
          />
        )}
        {render}
      </Box>
    </Flex>
  );
};
